import { gql, useMutation } from '@apollo/client';

import { GraphQLTypes } from 'src/lib/graphqlTypes';

export const useUpdateVariantReadme = () => {
  const [
    updateVariantReadmeMutation,
    {
      error: updateVariantReadmeError,
      data: updateVariantReadmeData,
      loading: updateVariantReadmeLoading,
    },
  ] = useMutation<
    GraphQLTypes.UpdateDemoGraphReadmeMutation,
    GraphQLTypes.UpdateDemoGraphReadmeMutationVariables
  >(gql`
    mutation UpdateDemoGraphReadmeMutation(
      $graphId: ID!
      $variant: String!
      $readme: String!
    ) {
      service(id: $graphId) {
        variant(name: $variant) {
          updateVariantReadme(readme: $readme) {
            id
          }
        }
      }
    }
  `);

  const updateVariantReadme = async ({
    graphId,
    variant,
    readme,
  }: GraphQLTypes.UpdateDemoGraphReadmeMutationVariables) => {
    return updateVariantReadmeMutation({
      variables: {
        graphId,
        variant,
        readme,
      },
      update: (cache) => {
        cache.evict({
          id: cache.identify({
            __typename: 'Service',
            id: graphId,
          }),
          fieldName: 'variant',
        });
      },
    });
  };

  return {
    updateVariantReadmeError,
    updateVariantReadmeData,
    updateVariantReadmeLoading,
    updateVariantReadme,
  };
};
